var map = {
	"./cn/gp.png": "aiAj",
	"./en/gp.png": "8W7r",
	"./th/gp.png": "kc8y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JSrU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav ^\.\/.*\/gp\.png$
// module id = JSrU
// module chunks = 1